import { DocumentReference } from "@angular/fire/firestore";
import { VenueBuilder } from "./venue.builder";
import { Menu } from "../menu/menu.model";
import { MenuBuilder, MenuBuilderState } from "../menu/menu.builder";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

export class Venue {
  public readonly reference: DocumentReference;
  public readonly city: DocumentReference;

  public readonly name: string;
  public readonly isActive: boolean;
  public readonly rank: number;

  public readonly thumbnail: string;
  public readonly description: string;
  public readonly image: string;

  public readonly redirect: boolean;
  public readonly redirectUrl: string;

  public readonly cityState: string;
  public readonly cityName: string;
  public readonly cityTimezone: string;

  public readonly createdBy: string;
  public readonly editedBy: string;

  public readonly menu: Menu;
  public readonly isTopDrinksActive: boolean;

  public readonly totalActivePasses: number;
  public readonly totalPasses: number;

  public readonly isBannerActive: boolean;
  public readonly bannerImage: string;

  public readonly hideTicketOrders: boolean;

  public readonly isBannerRedirectActive: boolean;
  public readonly bannerRedirectUrl: string;
  public menuBuilder: MenuBuilder;

  constructor(builder: VenueBuilder) {
    this.reference = builder.reference;
    this.isTopDrinksActive = builder.isTopDrinksActive;
    this.city = builder.city;
    this.cityName = builder.cityName;
    this.cityState = builder.cityState;
    this.cityTimezone = builder.cityTimezone;
    this.bannerRedirectUrl = builder.bannerRedirectUrl;
    this.isBannerRedirectActive = builder.isBannerRedirectActive;
    this.name = builder.name;
    this.isActive = builder.isActive;
    this.thumbnail = builder.thumbnail;
    this.rank = builder.rank;
    this.bannerImage = builder.bannerImage;
    this.isBannerActive = builder.isBannerActive;
    this.createdBy = builder.createdBy;
    this.editedBy = builder.editedBy ? builder.editedBy : null;
    this.redirect = builder.redirect;
    this.redirectUrl = builder.redirectUrl;
    this.image = builder.image;
    this.description = builder.description;
    this.totalActivePasses = builder.totalActivePasses;
    this.totalPasses = builder.totalPasses;
    this.menuBuilder = builder.menu ? builder.menu : null;
    this.menu = builder.menu ? builder.menu.build() : null;
    this.hideTicketOrders = builder.hideTicketOrders ? builder.hideTicketOrders : null;
  }
  dispose() {}

  get id(): string {
    return this.reference.id;
  }

  get path(): string {
    return this.reference.path;
  }

  get isPassError(): boolean {
    return this.isActive && this.totalActivePasses == 0;
  }

  public get isMenuSetup(): boolean {
    return this.menu != null;
  }

  get isTipDistributionActive(): boolean {
    return this.menu != null && this.menu.payments.isDistributeTippingActive;
  }

  get status(): string {
    if (this.isActive) return "GOOD";
    return "HIDDEN";
  }

  public addMenuBuilder() {
    this.menuBuilder = new MenuBuilder(
      MenuBuilderState.CreatingMenu,
      this.cityTimezone
    );
  }
  public editMenuBuilder() {
    this.menuBuilder = new MenuBuilder(
      MenuBuilderState.EditingMenu,
      this.cityTimezone
    ).edit(this.menu);
  }

  public async updateRank(newRank: number, httpClient: HttpClient, userJWT: string) {
    httpClient.post(`${environment.apiBaseUrl}/api/v1/venues/${this.id}/updateRank`, {
            id: this.id,
            rank: newRank,
        }, {
            headers: new HttpHeaders().set('Authorization', `${userJWT}`),
        }).toPromise()
        .catch((error) => {
            throw(error);
        })
  }
}

export const toAPIRequest = (venue: Venue): any =>{
  let venueAPIObject = {
    ...venue,
    city: venue.city.id,
    menu: venue.menu || null,
    editedBy: venue.editedBy || "",
    redirectUrl: venue.redirectUrl || "",
  } as any;

  if (venueAPIObject.menu) {
    venueAPIObject = {
        ...venueAPIObject,
        menu: venueAPIObject.menuBuilder.toJSON(),
    }
  }
  delete venueAPIObject.reference;
  delete venueAPIObject.menuBuilder;

  return venueAPIObject;
}
